import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CustomMenuItem } from '../models/menu-item.model';

@Injectable({
    providedIn: 'root',
})
/**
 * menu data service
 */
export class MenuDataService {

    public toggleMenuBar: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    getMenuList(): CustomMenuItem[] {
        return [
            {
                Label: 'Home', Icon: 'fa-home', RouterLink: '/dashboard', IsChildVisible: false, Visibility: ['ADMIN','PARTNER', 'SALES']
            },
            // {
            //     Label: 'Proposals', Icon: 'fa-home', RouterLink: '/proposals', IsChildVisible: false
            // },
            {                
                Label: 'Eligibility', Icon: 'fa-users', RouterLink: '/eligibility', IsChildVisible: false, Visibility: ['ADMIN', 'PARTNER', 'SALES']
            },
            {
                Label: 'Users', Icon: 'fa-users', RouterLink: '/users', IsChildVisible: false, Visibility: ['ADMIN', 'PARTNER', 'SALES']
            },
            // {
            //     Label: 'Reporting', Icon: 'fa-users', RouterLink: '/reporting', Childs: [], IsChildVisible: false
            // },
        
            // {
            //     Label: 'ContactUs', Icon: 'fa-envelope', RouterLink: '/main/contactus', Childs: [], IsChildVisible: false
            // }          
        ];
    }
}